export default __webpack_public_path__ + "static/media/3669_124681.e7cefe4d.svg";